import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új folyamat',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            }
        ],
        searchFields: [
            {
                name: "dataManagementProcess",
                label: "Adatkezelési folyamat",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "dataManagerId",
                label: "Adatkezelő",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getGdprPersonFilter,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "commonDataManagerId",
                label: "Közös adatkezelő",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getGdprPersonFilter,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "privacyOfficerId",
                label: "Adatvédelmi tisztviselő",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getGdprPersonFilter,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "dataManagerContactId",
                label: "Adatkezelő kapcsolattartó",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getGdprPersonFilter,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "goal",
                label: "Cél",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "dataProcessorName",
                label: "Adatfeldogozó neve",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "dataSecurityDescription",
                label: "Adatbiztonság leírás",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "proofOfAcceptanceFrom",
                label: "Elfogadás -tól",
                formSize: 3,
                formVisible: true,
                formType: 'date'
            },
            {
                name: "proofOfAcceptanceTo",
                label: "Elfogadás -ig",
                formSize: 3,
                formVisible: true,
                formType: 'date'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "siteId",
                label: "Telephely ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "dataManagementProcess",
                label: "Adatkezelési folyamat",
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "dataManagerId",
                label: "Adatkezelő",
                visibility: false,
                formSize: 4,
                formType: 'select',
                formVisible: true,
                formRequired: true,
                selectOptions: {
                    apiCallback: Api.getGdprPersonFilter,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "commonDataManagerId",
                label: "Közös adatkezelő",
                visibility: false,
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getGdprPersonFilter,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "privacyOfficerId",
                label: "Adatvédelmi tisztviselő",
                visibility: false,
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getGdprPersonFilter,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "dataManagerContactId",
                label: "Adatkezelő kapcsolattartó",
                visibility: false,
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getGdprPersonFilter,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "goal",
                label: "Cél",
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "pleas",
                label: "Jogalap",
                visibility: false,
                formSize: 4,
                formRequired: true,
                formVisible: true,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getPleaFilter,
                    formatOption: function (val) {
                        return val.pleaName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'pleaName',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "stakeholderCategories",
                label: "Érintettek kategóriái",
                visibility: false,
                formSize: 4,
                formRequired: true,
                formVisible: true,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getUserPersonTypeFilter,
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "personalDataCategories",
                label: "Kezelt személyes adatok kategóriái",
                visibility: false,
                formSize: 4,
                formRequired: true,
                formVisible: true,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getAllPersonalDataCategoryFilter,
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "recipientCategories",
                label: "Címzettek kategóriái",
                visibility: false,
                formSize: 4,
                formRequired: true,
                formVisible: true,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getDataManagementProcessRecipientCategoryFilter,
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "dataProcessorName",
                label: "Adatfeldogozó neve",
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "scheduledStorageTime",
                label: "Tervezett adattárolási határidő",
                sort: true,
                visibility: true,
                formType: 'number',
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "transmissionGuarantees",
                label: "Továbbítás garanciái",
                visibility: false,
                formSize: 4,
                formRequired: false,
                formVisible: true,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getDataManagementProcessTransmissionGuaranteeFilter,
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "dataSecurityDescription",
                label: "Adatbizonság leírása",
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "places",
                label: "Tárolási helyek",
                visibility: false,
                formSize: 4,
                formRequired: true,
                formVisible: true,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getDataManagementProcessPlaceFilter,
                    formatOption: function (val) {
                        return val.dataManagementPlace;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'dataManagementPlace',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "forms",
                label: "Tárolási formák",
                visibility: false,
                formSize: 4,
                formRequired: true,
                formVisible: true,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getDataManagementProcessFormFilter,
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "proofOfAcceptanceInfo",
                label: "Elfogadás/tudomásul vétel bizonyítása",
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "proofOfAcceptanceDate",
                label: "Elfogadás/tudomásul vétel dátuma",
                sort: true,
                visibility: true,
                slot_name: "productionTime_format",
                formType: 'date',
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "thirdCountryTransmissionRecipient",
                label: "3. országba továbbítás címzettje",
                visibility: false,
                formType: 'text',
                formSize: 12,
                formRequired: false,
                formVisible: true
            },
            {
                name: "createdBy",
                label: "Készítő",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "Módosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "Módosítás dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            },
        ]
    }
}
